module.exports = __webpack_public_path__ + "static/img/event_banner.c0cc8045.png";